import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { MdOutlineLayers } from "react-icons/md";

export type BackgroundMap = "topographic" | "satellite" | "dark";

type Props = {
  backgroundMap: BackgroundMap;
  setBackgroundMap: (backgroundMap: BackgroundMap) => void;
};

const backgroundMaps: { id: BackgroundMap; label: string }[] = [
  { id: "topographic", label: "Topografisch" },
  { id: "satellite", label: "Satelliet" },
  { id: "dark", label: "Donker" },
];

const BackgroundMapPicker: React.FC<Props> = ({ backgroundMap, setBackgroundMap }) => {
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  useEffect(() => {
    const clickHandler = () => setPopoverOpen(false);
    document.body.addEventListener("click", clickHandler);
    return () => {
      document.body.removeEventListener("click", clickHandler);
    };
  });

  return (
    <>
      {/* Open tooltip button */}
      <Box
        className="maplibregl-ctrl-group"
        position="absolute"
        top="10px"
        left="10px"
        zIndex="1000"
        background="white"
        height="30px"
        width="30px"
        display="flex"
        borderRadius="5px"
        justifyContent="center"
        alignItems="center"
        cursor="pointer"
        onClickCapture={(e) => {
          e.stopPropagation();
          setPopoverOpen(!popoverOpen);
        }}
      >
        <MdOutlineLayers size="sm" />
      </Box>

      {/* Select background layer */}
      <Box
        position="absolute"
        top="10px"
        left="50px"
        zIndex="1000"
        background="white"
        display="flex"
        borderRadius="5px"
        overflow="hidden"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        width="200px"
        transition="opacity 1s"
        cursor={popoverOpen ? "pointer" : ""}
        opacity={popoverOpen ? "1" : "0"}
      >
        {backgroundMaps.map((map, index) => {
          return (
            <Box
              key={map.id}
              paddingY={1}
              display="flex"
              width="100%"
              background={map.id === backgroundMap ? "#dee0e3" : ""}
              borderTop={index === 0 ? "" : "1px grey solid"}
              onClickCapture={(e) => {
                if (!popoverOpen) return;
                e.stopPropagation();
                setBackgroundMap(map.id);
              }}
            >
              <Text paddingLeft="1em">{map.label}</Text>
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export { BackgroundMapPicker };
